import NewsItem from "@/components/pages/MicroSite/Templates/FlowkitTemplate/NewsFeed/NewsItem";
import type { MicroSite } from "@/lib/api";

const NewsFeedGroup = ({data}:{data: MicroSite}) => { 

  return (
    <div className="flex relative flex-col w-full p-4 lg:p-8 gap-6  justify-center" >
      <div className="grid md:grid-cols-2 lg:grid-cols-3 md:gap-8 gap-6 w-full">
      {Array.isArray(data?.newsFeedSection?.newsFeedSectionDetails) && data.newsFeedSection.newsFeedSectionDetails.length > 0 && data?.newsFeedSection?.newsFeedSectionDetails.map((item, index) => (
           // Item index is passed to help identify which item is being deleted because multiple items can have the same content and there is no unique id
        <NewsItem key={index} data={item} />
      ))}
    </div>

    </div>
    
  )
}

export default NewsFeedGroup